module.exports = __webpack_public_path__ + "static/logo-0e1e1dbb043d2887f76a46d8b554d1f5.svg";